import { render, staticRenderFns } from "./psychologyStuRecord.vue?vue&type=template&id=661344d4&"
import script from "./psychologyStuRecord.vue?vue&type=script&lang=js&"
export * from "./psychologyStuRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports